import { Injectable } from '@angular/core';
import { BaseReportActionsHandler } from '../base-report-actions-handler';
import { IContact } from '../../../../../type_definitions/datatypes';
import { GaDeferredService, IGADeferred } from '../../../services/ga-deferred.service';
import { Override } from '../../../app-decorators';
import { REPORT_ACTION_CANCELLED } from '../report-actions.helper';
import { SendMailService } from '../../../send-mail/send-mail.service';
import { IMailRequest } from '../../../send-mail/send-mail-data.service';

@Injectable()
export class SendMailHandlerService extends BaseReportActionsHandler {
  constructor(
    private deferredService: GaDeferredService,
    private sendMailService: SendMailService
  ) {
    super();
  }

  @Override(BaseReportActionsHandler)
  public execute(): Promise<any> {
    const deferred: IGADeferred<any> = this.deferredService.defer();
    const selectedContacts: IContact[] = this.sendMailService.getSelectedContacts(this.rowSelection);

    this.sendMailService.showSendMailDialog(
      undefined,
      undefined,
      selectedContacts,
      // when user clicks send mail
      (sendMailModel: IMailRequest) => {
        deferred.resolve({
          Demaito: sendMailModel.to, // comma separated list of contact IDs + email addresses
          Demaicc: sendMailModel.cc, // comma separated list of contact IDs + email addresses
          Demaibc: sendMailModel.bcc, // comma separated list of contact IDs + email addresses
          Desubje: sendMailModel.subject,
          Dembody: sendMailModel.body
        });

        return Promise.resolve();
      },
      // when user clicks cancel
      () => {
        deferred.reject(REPORT_ACTION_CANCELLED);
      }
    );

    return deferred.promise;
  }
}